module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAAXNSR0IArs4c6QAAATNJREFUKFON0r9KA0EQBvBv3CvMAwixEE4QhBDI5rY0RQQfQUHfInkDC0tB7C0FC7UUAgoRgqBF7vYNcqWF4MFZWLj7SY6chMDFbLkzv5nZP2KMuQVwiIVFstgRkd54PL4sw2KMIcm+994uGK2UugDw470/TpLkvigwBc65fWvt8zzQWneVUkMAPQDnzrmutfalErRarU4QBCOSKYBNAGtZlm1UAgCB1rozO0ddRG6899vLwN+EWutQKTVxzq0GGo1GvVarTfI831qpw7RVGIbraZp+/wtm1R9JPsVx3F8KZslDkl8i0iR5VgnKZAAfJAcicuqcO6oExpjRdPYy2Xt/kiTJnURR9AngFcB7eY8kr0XkSkQyAM0yuXiTdrt9ICJ789+C5IOI7ALYAfAWx/GgjP8CLujLW2g3vO0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/imgs/user/edit.png
// module id = GLfh
// module chunks = 0